import { EventEmitter, InjectionToken } from '@angular/core';
import { map, filter, takeUntil, switchMap, delay } from 'rxjs/operators';
import { NEVER, never, Observable, of } from 'rxjs';
// enums
import { EventCustom } from '../enum/event-custom.enum';
import { EventName } from '../enum/event-name.enum';
// interfaces
import { EventStateConfig } from '../interfaces/event-state-config.interface';
import { StateConfig } from '../interfaces/state-config.interface';

export const STATE_CONFIG = new InjectionToken<StateConfig>('state.config', {
    providedIn: 'platform',
    factory: () => {
        return STATE_CONFIG_VALUE;
    },
});

export let actionState: EventEmitter<EventStateConfig> = new EventEmitter();

export const STATE_CONFIG_VALUE: StateConfig = {
    queryParams: {},
    authentication: {},
    register: {},
    accounts: {},
    operations: {},
    changes: {},
    recoverPassword: {},
    states: [],
    set: (event?: EventStateConfig): void => {
        const states = STATE_CONFIG_VALUE.states?.map((item) => {
            if (
                item.eventCustom === event.eventCustom &&
                item.eventName === event.eventName
            ) {
                item = event;
            }
            return item;
        });

        if (
            !states.find(
                (item) =>
                    item.eventCustom === event.eventCustom &&
                    item.eventName === event.eventName
            )
        ) {
            states.push(event);
        }

        STATE_CONFIG_VALUE.states = states;

        actionState.emit(event);
    },
    get: (eventCustom: EventCustom, eventName: EventName) => {
        return STATE_CONFIG_VALUE.states?.find(
            (x) => x.eventCustom === eventCustom && x.eventName === eventName
        );
    },
    on: (eventCustom: EventCustom, eventName: EventName): Observable<any> => {
        return actionState.pipe(
            switchMap(
                (res) => res.eventCustom === eventCustom && res.eventName === eventName ? of(res) : NEVER
            )
        );
    },
};
